export const statuses = [
  'CREATED',
  'PENDING',
  'ERROR',
  'REJECTED',
  'PROCESSED'
]
